import { enableSentryTracing } from "@toruslabs/http-helpers";
import log from "loglevel";

import config from "@/config";

export async function installSentry(): Promise<void> {
  if (!config.sentryDsn) return;
  const [Sentry, loglevelSentryModule] = await Promise.all([import("@sentry/browser"), import("@toruslabs/loglevel-sentry")]);
  const { LoglevelSentry, redactBreadcrumbData } = loglevelSentryModule;

  Sentry.init({
    dsn: config.sentryDsn,
    environment: config.buildEnv,
    release: `passwordless@${config.version}`,
    integrations: [],
    ignoreErrors: [
      // Happen when user click 'X' on the browser (ref https://forum.sentry.io/t/typeerror-failed-to-fetch-reported-over-and-overe/8447/2)
      "TypeError: Failed to fetch", // All except iOS and Firefox
      "TypeError: cancelled", // iOS
      "TypeError: NetworkError when attempting to fetch resource.", // Firefox
    ],
    sampleRate: Number.parseFloat(config.sentrySampleRate),
    tracesSampleRate: Number.parseFloat(config.sentrySampleRate) / 10,
    normalizeDepth: 8,
    beforeBreadcrumb(breadcrumb) {
      breadcrumb.data = redactBreadcrumbData(breadcrumb.data);
      return breadcrumb;
    },
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });

  const plugin = new LoglevelSentry(Sentry);
  plugin.install(log);
  enableSentryTracing(Sentry, [config.authServerUrl], []);
}
